import { ReactComponent as NoResultsIcon } from '../../assets/icons/no-results-icon/no-results.svg';
import Box from '../ui/Box/Box';
import Typography from '../ui/Typography/Typography';

const NoResults = () => {
  return (
    <Box
      sx={{
        mt: '80px',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
      data-testid="no-results"
    >
      <NoResultsIcon />
      <Typography
        sx={{
          fontSize: '24px',
          fontWeight: '236px',
          color: theme => theme.palette.appGrey.darkGray,
        }}
      >
        Sorry, no results found
      </Typography>
    </Box>
  );
};

export default NoResults;
